import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Icon, Card, Button, Grid, Input} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import SetSalesTable from './table';
import BarCharSets from './chart/bar';
import './setSalesList.scss';

const today = moment();

class SetsSalesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'startDateFilter': today.format(noTimeZoneShortISODate),
      'endDateFilter': today.format(noTimeZoneShortISODate),
    };
    this.search = this.search.bind(this);
    this.donwload = this.donwload.bind(this);
    this.donwloadDetail = this.donwloadDetail.bind(this);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.SetSales,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.changeSetsalesListPageSize(20);
    this.props.changeSetSalesListPage(0);
    this.search();
  }

  search() {
    const {startDateFilter, endDateFilter} = this.state;
    this.props.deleteAccesoriesSetsHead();
    this.props.fetchAccesoriesSetsHead(startDateFilter, endDateFilter);
  }

  donwload() {
    const {startDateFilter, endDateFilter} = this.state;
    this.props.downloadSetSalesFile(startDateFilter, endDateFilter);
  }

  donwloadDetail() {
    const {startDateFilter, endDateFilter} = this.state;
    this.props.downloadSetSalesDetailFile({
      startDateFilter,
      endDateFilter},
    'ALL',
    'ALL',
    );
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted === startDateFilter) {
      return;
    }
    this.setState({'startDateFilter': dateFormatted});
    if (!endDateFilter) {
      this.setState({'endDateFilter': dateFormatted});
    }
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted === this.state.endDateFilter) {
      return;
    }
    this.setState({'endDateFilter': dateFormatted});
  }

  renderSearchButton() {
    const {loading, downloading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary'
        disabled={loading || downloading}
        onClick={this.search}
      >
        Consultar
      </Button>
    );
  }

  renderDownloadButton() {
    const {loading, downloading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary download'
        disabled={loading || downloading}
        onClick={this.donwload}
      >
        <Icon name='download' />
        Descargar
      </Button>
    );
  }

  renderDownloadButtonDetail() {
    const {loading, downloading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary download detail'
        disabled={loading || downloading}
        onClick={this.donwloadDetail}
      >
        <Icon name='download' />
        Descargar Detalle
      </Button>
    );
  }

  render() {
    const {startDateFilter, endDateFilter} = this.state;
    const {loading, downloading} = this.props;

    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta Ventas Accesorios</h2>
              <div className='title-bar-actions'>
                {this.renderSearchButton()}
                {this.renderDownloadButton()}
                {this.renderDownloadButtonDetail()}
              </div>
            </div>

            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Fecha Inicio</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        startDateFilter ?
                          moment(startDateFilter, noTimeZoneShortISODate).toDate() :
                          null
                      }
                      onChange={this.changeStartDate}
                      locale='es'
                      placeholderText='Fecha Inicio'
                      disabled={loading || downloading}
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Fecha Fin</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        endDateFilter ?
                          moment(endDateFilter, noTimeZoneShortISODate).toDate() :
                          null
                      }
                      onChange={this.changeEndDate}
                      locale='es'
                      placeholderText='Fecha Fin'
                      disabled={loading || downloading}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        <BarCharSets />
        <SetSalesTable startDateFilter={startDateFilter} endDateFilter={endDateFilter}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'loading': state.setsHeadSales.loading,
    'downloading': state.setsHeadSales.downloading,
  };
};

const {
  fetchAccesoriesSetsHead,
  deleteAccesoriesSetsHead,
  changeSetSalesListPage,
  changeSetsalesListPageSize,
  downloadSetSalesDetailFile,
  downloadSetSalesFile,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchAccesoriesSetsHead,
  deleteAccesoriesSetsHead,
  changeSetSalesListPage,
  changeSetsalesListPageSize,
  downloadSetSalesDetailFile,
  downloadSetSalesFile,
  navigateTo,
})(SetsSalesList);
